import { useEffect, useState } from 'react'
import { sentryIdentify } from 'sentry/sentryError'
import { getCard } from 'api/credit-card'
import CreditCard from 'pages/myCard/components/CreditCard'
import Message from './Message'
import PauseToggle from './PauseToggle'
import AuxModals from './AuxModals'
import CardButtons from './CardButtons'

const VirtualCardTab = () => {
  // card data
  const [card, setCard] = useState(null)
  // if is getting card data
  const [loadingStatus, setLoadingStatus] = useState(false)
  // loading first render
  const [loadingPage, setLoadingPage] = useState(true)

  // neccesary for showing a diferent page
  const cardStatusError =
    card?.card_status === 'ERROR_CREATION' ||
    card?.card_status === 'ERROR_ASSOCIATION'

  const cardIsActive = card?.card_status === 'ACTIVE'

  const cardIsDisabled =
    card?.card_status === 'PENDING' ||
    !cardIsActive ||
    Boolean(card?.error) ||
    card?.card_status === 'BLOCKED' ||
    card?.card_status === 'DISABLED' ||
    (card !== null && Object.keys(card).length === 0)

  useEffect(() => {
    getCardData()
  }, [])

  function getCardData() {
    if (loadingStatus) return
    setLoadingStatus(true)

    getCard({ type: 'VIRTUAL' })
      .then((res) => {
        if (res.success) {
          setCard(res.data)
        }
      })
      .catch((error) => sentryIdentify(error))
      .finally(() => {
        setLoadingPage(false)
        setLoadingStatus(false)
      })
  }

  const showSwitch =
    !card?.error &&
    !loadingStatus &&
    (card?.card_status === 'ACTIVE' || card?.card_status === 'BLOCKED')

  // COMPONENT RETURNS
  if (cardStatusError) {
    return <AuxModals type='CONTACT_ADVISOR' />
  }

  if (loadingPage) {
    return <span />
  }

  return (
    <div>
      <div className='w-full md:gap-3 md:grid md:grid-cols-2'>
        {/* TARJETA */}
        <CreditCard
          setLoading={setLoadingStatus}
          disabled={cardIsDisabled}
          loading={loadingStatus}
          card={card}
        />
        {/* SWITCH */}
        {showSwitch && (
          <PauseToggle
            loadingStatus={loadingStatus}
            card={card}
            getCard={getCardData}
          />
        )}
      </div>

      {/* MESSAGES */}
      {/* Blocked card message */}
      {card?.card_status === 'DISABLED' && !loadingStatus && (
        <div className='w-full mt-8'>
          <Message
            className='bg-blue-900 h-12 py-4'
            text='Su tarjeta fue bloqueada.'
          />
        </div>
      )}

      {card?.card_status === 'PENDING' && (
        <div className='w-full mt-8'>
          <Message
            className='bg-blue-900 h-12 py-4'
            text='Tu tarjeta está en proceso de activación. Volvé en unos minutos.'
          />
        </div>
      )}

      {/* BOTONES */}
      <CardButtons typeCard='VIRTUAL' card={card} getCardData={getCardData} />
    </div>
  )
}

export default VirtualCardTab
